import request from '@/utils/request'

let Ma_emergency_planApi = {

  /*应急预案列表*/
  list(data) {
    return request._post('/shop/plus.ma_emergency_plan.Index/index', data);
},
/*添加应急预案*/
add(data) {
    return request._post('/shop/plus.ma_emergency_plan.Index/add', data);
},
/*修改应急预案*/
edit(data) {
    return request._post('/shop/plus.ma_emergency_plan.Index/edit', data);
},
/*删除应急预案*/
del(data) {
    return request._post('/shop/plus.ma_emergency_plan.Index/del', data);
},
/*应急预案详情*/
detail(data) {
  return request._post('/shop/plus.ma_emergency_plan.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.ma_emergency_plan.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.ma_emergency_plan.Setting/getSetting', data, errorback);
    },

    importData(data) {
        return request._post('/shop/plus.ma_emergency_plan.Index/import', data);
    },
    exportExcel(data) {
        return request._post('/shop/plus.ma_emergency_plan.Index/export', data);
    },
}
export default Ma_emergency_planApi;



// WEBPACK FOOTER //
// ./src/api/ma_emergency_plan.js